/* EMINOVÈE fail-closed cart UI: use the server-rendered, gated full cart. */
(function (window) {
  'use strict';
  window.ShopifyAPI = window.ShopifyAPI || {};
  window.ajaxCart = {
    init: function () {},
    load: function () {}
  };
}(window));
